/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Sport_RunningInputs */

const en_ui_sport_running = /** @type {(inputs: Ui_Sport_RunningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Running`)
};

const de_ui_sport_running = /** @type {(inputs: Ui_Sport_RunningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laufen`)
};

/**
* | output |
* | --- |
* | "Running" |
*
* @param {Ui_Sport_RunningInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_sport_running = /** @type {((inputs?: Ui_Sport_RunningInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Sport_RunningInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_sport_running(inputs)
	return de_ui_sport_running(inputs)
});